/* 
  点击logo定位到首页
  pc logo + text
  m 小房子logo
*/
import { useContext } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import logo from '@/assets/icon/logo.png';
import { StoreContext, namespace } from '@/context';
import Styles from './index.module.scss';

interface IHomeLogo {
  isMobile: boolean;
}

const HomeLogo = ({
  isMobile
}:IHomeLogo) => {
  const { state } = useContext(StoreContext);
  const { track, TRACK_EVENTS } = state[namespace.app].sensors || {};
  return (
    <Link 
      href="/" 
      className={Styles.logoWrapper}
      onClick={() => {
        track?.(TRACK_EVENTS?.[namespace.detail].logoClick.name, {}, namespace.detail);
      }}
    >
      {
        isMobile ? <i>mobile</i> : 
        <Image
          src={logo}
          loader={({ src }) => src}
          alt="logo"
          width={119}
          height={28}
        />
      }
    </Link>
  )
} 
export default HomeLogo;